import PatientsRepository from '@/repositories/PatientsRepository'

const testsStore = {
    namespaced: true,
    state: {
        test: {},
        currentSlide: 0,
        completed: false,
        previousTestResults: [],
        DBResults: {},
        resultInfo: {}
    },
    mutations: {
        incrementSlide (state, data = null) {
            data != null ? state.currentSlide += data : state.currentSlide++
        },
        setPreviousTestResults (state, data) {
            state.previousTestResults = data
        },
        setTestCompletedThisMonth (state, data) {
            state.DBResults = data
            state.completed = true
        },
        setTestCompleted (state) {
            state.completed = true
        },
        setDBResult (state, data) {
            state.DBResults = {generalResult: data.result, percentage: data.percentage, userId: data.userId, date: data.date, testId: data.testId, testName: data.testName, dimensions: data.dimensions}
        },
        pushLastTestCompleted (state) {
            state.previousTestResults.push(state.DBResults)
        },
        setResultInfo (state, data) {
            state.resultInfo = data
        }
    },
    actions: {
        saveTestResult ({commit, state}, testInfo) {
            commit('setDBResult', testInfo)
            commit('pushLastTestCompleted')
            commit('setTestCompleted')
            PatientsRepository.fillSelfEvaluationTest(state.DBResults)
        }
    }
}

export default testsStore


// WEBPACK FOOTER //
// ./src/store/modules/tests.js